import React from "react";
import { useState,useEffect } from "react";
import UsePanel from "./UserPanel";
import OrderStatus from "./OrderStatus";
import Notifications from "./Notifications";
import SocialSource from "./SocialSource";
import OverView from "./OverView";
import RevenueByLocation from "./RevenueByLocation";
import LatestTransation from "./LatestTransation";
import { Button } from "reactstrap";
import AddIcon from '@mui/icons-material/Add';
import { Row, Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  document.title = "Dashboard | Easybox - Logistics";

  const[email, setEmail] = useState("");
  const[storeID, setStoreid] = useState('');
  const[role, setRole] = useState('');

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch('https://easyboxstoresapi.uuidesign.xyz/api/profile', {
          credentials: 'include', // to send cookies
        });
        const data = await res.json();

        if (data.valid) {
          setEmail(data.email)
        } else {}
      } catch (error) {} 
    };

    fetchProfile();
  }, []);

  //get store id
  useEffect(()=>{
   const fetchData = async()=>{
      try{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getUserdetails?email=${email}`);
        const data = await res.json();
        setStoreid(data.store_id)
        setRole(data.role)
      }
      catch(err){}
   }

   if(email){
    fetchData();
   }
   
  },[email])

  const navigate = useNavigate();

  const newOrder =()=>{
    navigate('/order')
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Easybox" breadcrumbItem="Dashboard" />
          {/* User Panel Charts */}

          {/* New consignment */}
          <Button onClick={newOrder} color='primary' style={{display:'flex',alignItems:'center',marginBottom:'20px'}}><AddIcon />New Order</Button>
          
          {(role !== 'Admin' || role !== 'Manager') &&
            <p>Data not available for your role</p>
          }
          
          {(role == 'Admin' || role == 'Manager') &&
            <>
              <UsePanel />

            <Row>
              {/* Overview Chart */}
              <OverView store={storeID}/>
              {/* Social Source Chart */}
              <SocialSource />
            </Row>

            <Row>
              {/* Order Stats */}
              <OrderStatus store={storeID} />
              {/* Notifications */}
              <Notifications store={storeID}/>
              {/* Revenue by Location Vector Map */}
              <RevenueByLocation />
            </Row>

            {/* Latest Transaction Table */}
            <LatestTransation store={storeID} />

            </>
          
          }
          
         
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
